import React from "react";
import {  AppBar, Toolbar,  Button, Stack } from "@mui/material";

function Navbar() {
    return (
        <AppBar
            position="static"
            sx={{
                background: "#141b2d",
                // boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
        >
            <Toolbar
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px 30px",
                }}
            >
                <Stack direction="row" spacing={3} sx={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
                    <Button
                        color="inherit"
                        sx={{
                            color: "#fff",
                            textDecoration: "none",
                            fontWeight: "600",
                            "&:hover": {
                                color: "#70d8bd",
                            },
                        }}
                        href="https://travelnet.in/"
                    >
                        Home
                    </Button>
                    <Button
                        color="inherit"
                        sx={{
                            color: "#fff",
                            textDecoration: "none",
                            fontWeight: "600",
                            "&:hover": {
                                color: "#70d8bd",
                            },
                        }}
                        href="https://travelnet.in/contact"
                    >
                        Contact Us
                    </Button>
                </Stack>
            </Toolbar>
        </AppBar>
    );
}

export default Navbar;
